import React, { Suspense, useState } from 'react'
import { Link } from 'react-router-dom'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Tab } from '@mui/material'
import { Box } from '@mui/material'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'

import CampaignRewards from './rewards_components/CampaignRewards'
import DistributorRewards from './rewards_components/DistributorRewards'

function FaberRewardsDashboard() {
  const [tabValue, setTabValue] = useState('1')
  const handleTabChange = (event, newNum) => setTabValue(newNum)

  return (
    <Suspense fallback={<LayoutSkeleton />}>
      <TabContext value={tabValue}>
        <PageLayoutV2 header={'Manage Rewards'}>
          <ColorBox sx={{ minWidth: '1000px' }}>
            <TabList
              onChange={handleTabChange}
              aria-label='lab API tabs example'
            >
              <Tab label='Campaign' value='1' component={Link} to='#campaign' />
              <Tab
                label='Distributor'
                value='2'
                component={Link}
                to='#distributor'
              />
            </TabList>

            <TabPanel value='1'>
              <ColorBox>
                <Box>
                  <CampaignRewards />
                </Box>
              </ColorBox>
            </TabPanel>
            <TabPanel value='2'>
              <ColorBox>
                <Box>
                  <DistributorRewards />
                </Box>
              </ColorBox>
            </TabPanel>
          </ColorBox>
        </PageLayoutV2>
      </TabContext>
    </Suspense>
  )
}

export default FaberRewardsDashboard
